module.exports = __webpack_public_path__ + "img/penguin_fancy.7eace0d2.svg";